import { getMessages } from "../services/apiChatbot";
import { hasAllQueryValues, useMappedQuery } from "./queryUtils";

export function useGetChatbotMessages(cardId, userId) {
  const {
    messages,
    isLoading,
    error,
    isError,
    refetch,
  } = useMappedQuery({
    queryKey: ["getMessage", cardId, userId],
    queryFn: () => getMessages(cardId, userId),
    enabled: hasAllQueryValues(cardId, userId),
    dataKey: "messages",
  });

  return { isLoading, error, messages, getMessageRefetch: refetch, isError };
}
